/**
 * htmlToPlainText — Estrae il testo puro da una stringa HTML.
 * Usato per preview brevi (line-clamp), toast, TTS e ovunque non serva rendering
 * ricco. Preserva emoji e punteggiatura. Sicuro contro XSS (no innerHTML).
 */
export function htmlToPlainText(html) {
  if (!html) return "";
  if (!/<[a-z][\s\S]*?>/i.test(html)) return html; // non contiene tag
  try {
    const doc = new DOMParser().parseFromString(html, "text/html");
    // Sostituisce </p><p> e </li> con newline per preservare la separazione logica
    doc.querySelectorAll("p, li, br, h1, h2, h3, blockquote").forEach((el) => {
      el.append(" ");
    });
    return (doc.body?.textContent || "").replace(/\s+/g, " ").trim();
  } catch {
    return html.replace(/<[^>]*>/g, " ").replace(/\s+/g, " ").trim();
  }
}
